/**
 * @generated SignedSource<<a26ed67eb2bbe96d1ad698e66b3aeff7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ElementTypeV2 = "clozeText" | "file" | "multipleChoice" | "order" | "podcast" | "randomMultipleChoice" | "text" | "video" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ProjectSearchFilters_QueryFragment$data = {
  readonly Learn: {
    readonly GetAvailableTags: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    }>;
    readonly Tags: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly colorHex: string;
          readonly id: string;
          readonly name: string;
        };
      } | null> | null;
    };
  };
  readonly LearnV2: {
    readonly GetAvailableFilters: {
      readonly availableAttachmentTypes: ReadonlyArray<string>;
      readonly availableCertificates: ReadonlyArray<string>;
      readonly elementTypes: ReadonlyArray<ElementTypeV2>;
    };
  };
  readonly " $fragmentType": "ProjectSearchFilters_QueryFragment";
};
export type ProjectSearchFilters_QueryFragment$key = {
  readonly " $data"?: ProjectSearchFilters_QueryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectSearchFilters_QueryFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectSearchFilters_QueryFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LearnQueries",
      "kind": "LinkedField",
      "name": "Learn",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Tag",
          "kind": "LinkedField",
          "name": "GetAvailableTags",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TagsConnection",
          "kind": "LinkedField",
          "name": "Tags",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TagsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Tag",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "colorHex",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LearnV2Queries",
      "kind": "LinkedField",
      "name": "LearnV2",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AvailableFilterV2",
          "kind": "LinkedField",
          "name": "GetAvailableFilters",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "elementTypes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "availableCertificates",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "availableAttachmentTypes",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "a843f3e0e3a15529984661fb303c5f89";

export default node;
